import { SelfFixConfig } from '@self-fix/util-models';
import { AppConfig } from '../../models/config/app-config.type';

export const selfFixConfigFactory = ({
  ...config
}: AppConfig): SelfFixConfig => ({
  commonApi: config.commonApi,
  features: {},
});
